import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { blockBackgroundColors } from '@constants';
import { Container, Flex } from '../grid';
import { CardListing } from '../card-listing';
import { cmsImagePropTypes } from '../../prop-types';
import { LinkCard } from '../card';
import { linkCardItemsQuery, matrixBlockQuery } from '../../content/query-snippets';
import { BlockHeader } from '../block-header';

const LinkCardBlock = ({ heading, viBody, linkCardItems, viBackground }) => {
  const currentBackgroundColor = blockBackgroundColors?.[viBackground];

  const children = (
    <Flex
      backgroundColor={currentBackgroundColor}
      py={currentBackgroundColor !== 'transparent' && currentBackgroundColor && { xs: '64px', lg: '120px' }}
      my={(currentBackgroundColor === 'transparent' || !currentBackgroundColor) && { xs: '64px', lg: '120px' }}
      width="100%"
      justifyContent="center"
    >
      <Container variant="featuredContent">
        <BlockHeader heading={heading} body={viBody} />
        <Flex justifyContent="center">
          <Flex width={{ xs: 12 / 12 }} justifyContent="center">
            {!isEmpty(linkCardItems) && (
              <CardListing
                cardAlignment="center"
                CardComponent={LinkCard}
                cardWidth={{ xs: 6 / 12, md: '212px' }}
                imageTransformIsRequired
                items={linkCardItems}
              />
            )}
          </Flex>
        </Flex>
      </Container>
    </Flex>
  );

  return children;
};

LinkCardBlock.propTypes = {
  viBody: PropTypes.string,
  heading: PropTypes.string.isRequired,
  linkCardItems: PropTypes.arrayOf(
    PropTypes.shape({
      externalLink: PropTypes.string,
      heading: PropTypes.string,
      image: PropTypes.arrayOf(cmsImagePropTypes),
    })
  ).isRequired,
  viBackground: PropTypes.oneOf(['transparent', 'offWhite']),
};

LinkCardBlock.defaultProps = {
  viBody: null,
  viBackground: 'transparent',
};

LinkCardBlock.query = `
  ... on contentMatrix_linkCardBlock_BlockType {
    ${matrixBlockQuery}
    ${linkCardItemsQuery}
    viBody
    heading
    viBackground
  }
`;

export { LinkCardBlock };
